import { Slice } from "../store.decl";

export type ExpandedStateSliceState = {
  isExpanded: boolean;
  setIsExpanded: () => void;
};

export const createExpandedStateSlice: Slice<ExpandedStateSliceState> = (
  set
) => ({
  isExpanded: false,
  setIsExpanded: () => set((state) => ({ isExpanded: !state.isExpanded })),
});
